var productCardMarkup = 
  `<div class="swym-wishlist-grid">
		{{#products}} 
	<a aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"><img alt="" class="swym-wishlist-image swymhover_img" src="{{note}}"></div>
		<div class="swym-field_container">
		<button class="swym-is-button">
		<div class="swym-title swym-title-1">
			{{dt}}
		</div></button>
		<div style="display: none" class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{displayPrice}}
			</div>
        </div>
		<div class="favorite-product_container">

		{{#cprops}}
			<p class="grid-item grid-item-1 product-prop" data-value="{{ Color }}">Color:</p>
			<p class="grid-item grid-item-2 product-prop" data-value="{{ Color }}">{{ Color }}</p>
			<p class="grid-item grid-item-1 product-prop" data-value="{{ Nose_Bridge }}">Nose Bridge:</p>
			<p class="grid-item grid-item-2 product-prop" data-value="{{ Nose_Bridge }}">{{ Nose_Bridge }}</p>
			<p class="grid-item grid-item-1 product-prop" data-value="{{ Materials }}">Material:</p>
			<p class="grid-item grid-item-2 product-prop" data-value="{{ Materials }}">{{ Materials }}</p>
			<p class="grid-item grid-item-1 product-prop" data-value="{{ Frame_Size }}">Frame size:</p>
			<p class="grid-item grid-item-2 product-prop" data-value="{{ Frame_Size }}">{{ Frame_Size }}</p>
		{{/cprops}}

		</div>
        <form action="{{du}}">
            <button class="favorite-view-item">
                <span>View Item</span>
            </button>
        </form>
		</div>
    </a> 
       {{/products}}
	</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function getProductDetails(swat,obj,cb) {
  return swat.getProductDetails(
  obj,
  cb
  //   ,
  // function(productJson) {
  //   console.log('i', productJson)
  //   return productJson
  // }
);
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		// console.log('wishlistproducts', products);
        var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p, i) {          
          p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
          p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
          p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
          // p.pius = allPromises[i].images[1];
          // allPromises[i].then(function(val){ console.log('val', val)});
          p.displayPrice = p?.cprops?.Disp_Name ? p?.cprops?.Disp_Name : p.cu + p.pr;

          return p;
		});
    
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
		
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		// console.log("Successfully added product to cart.", c);
	}, function(e) {
		// console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	// console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}